import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SidebarContent } from './Sidebar';

export const navModule = createFrontendModule({
  pluginId: 'app',
  featureFlags: [
    {
      name: 'developer-mode',
      description: 'Show developer-focused navigation items such as DevTools and Visualizer.',
    },
  ],
  extensions: [SidebarContent],
});
